<template>
  <div class="video-container">
    <transition name="fade">
      <div
        v-if="videoSwitch"
        class="transition-holder">
        <video
          :src="videoPath()"
          autoplay
          loop
          muted
          playsinline
          class="video"
          style="object-fit: cover; object-position: 50% 50%;"/>
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="!videoSwitch"
        class="transition-holder">
        <video
          :src="videoPath2()"
          autoplay
          loop
          muted
          playsinline
          class="video"
          style="object-fit: cover; object-position: 50% 50%;"/>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    videos: {
      type: Array,
      default: () => [],
    },
    activeSection: {
      type: String,
      default: 'phase-1',
    },
  },
  data() {
    return {
      videoSrc: 'collage1.mp4',
      videoSrc2: 'collage1.mp4',
      videoSwitch: false,
    };
  },
  watch: {
    activeSection() {
      setTimeout(() => {
        this.checkVideoSrc();
      }, 500);
    },
  },
  mounted() {
    this.checkVideoSrc();
  },
  methods: {
    checkVideoSrc() {
      let newSrc = '';
      for (let i = 0; i < this.videos.length; i += 1) {
        if (this.videos[i].section === this.activeSection) {
          newSrc = this.videos[i].src;
        }
      }

      this.videoSwitch = !this.videoSwitch;

      if (this.videoSwitch) {
        this.videoSrc = newSrc;
      } else {
        this.videoSrc2 = newSrc;
      }
    },
    videoPath() {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`assets/videos/${this.videoSrc}`);
    },
    videoPath2() {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`assets/videos/${this.videoSrc2}`);
    },
  },
};
</script>
<style lang="scss" scoped>
  .video-container {
    position: fixed;
    width: 100%;
    height: 110%;
    left: 0;
    top: 0;
    z-index: 1;
    background-image: url('../assets/img/static-bg.jpg');
    background-position: top center;
    background-size: cover;
    background-color: #e4ddc7;
  }

  .video {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    pointer-events: none;
  }

  .transition-holder {
    opacity: 1;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/BackgroundVideo.vue